import { useState } from 'react'

import { captureException, withErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'
import { nanoid } from 'nanoid'

import { RouterSheetWithDirtyCheck } from '@/components/atoms/Sheet/RouterSheetWithDirtyCheck'
import { SentryErrorPage } from '@/pages/error/SentryErrorPage'
import { RegionPromotionCreateFormPage } from '@/pages/promotions/forms/RegionPromotionCreateFormPage'
import { RegionPromotionPage } from '@/pages/promotions/RegionPromotionPage'

export const PromotionListWithFormComponent = () => {
  const { key } = Route.useLoaderData()
  const [isDirty, setIsDirty] = useState(false)

  return (
    <>
      <RegionPromotionPage />
      <RouterSheetWithDirtyCheck className="h-full w-[600px]" isDirty={isDirty}>
        <RegionPromotionCreateFormPage key={key} onDirtyChange={setIsDirty} />
      </RouterSheetWithDirtyCheck>
    </>
  )
}

export const Route = createFileRoute('/promotions/$initiativeId/$regionId/create')({
  component: withErrorBoundary(PromotionListWithFormComponent, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  loader: () => ({
    key: nanoid(),
  }),
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
